import { render, staticRenderFns } from "./wizard-progress.vue?vue&type=template&id=53fc20c0"
import script from "./wizard-progress.vue?vue&type=script&lang=ts"
export * from "./wizard-progress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports